module.exports = __webpack_public_path__ + "img/3.ab6582d8.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":839,"height":504,"variants":[{"file":"img/3-480w.78bd08a065d8.webp","width":480},{"file":"img/3-839w.cca2018e48f6.webp","width":839}]};
}